<script setup lang="ts">
import { ref } from "vue"

import HeaderAuthed from "@/components/shared/HeaderAuthed.vue"
import MainContainer from "@/components/shared/MainContainer.vue"
import SideMenu from "@/components/shared/SideMenu.vue"

const props = defineProps({
  title: String,
})

const sideMenuRef = ref<InstanceType<typeof SideMenu> | null>(null)
const shifted = ref(false)

function handleToggleSideMenu() {
  sideMenuRef.value?.toggleOpen()
  shifted.value = !shifted.value
}
</script>

<template>
  <SideMenu ref="sideMenuRef" />
  <div class="main-container" :class="{ shifted: shifted }">
    <HeaderAuthed :title="title" @toggleSideMenu="handleToggleSideMenu()" />
    <MainContainer>
      <slot />
    </MainContainer>
  </div>
</template>

<style scoped>
.main-container {
  width: calc(100% - var(--side-menu-width));
  margin-left: var(--side-menu-width);
  transition: margin-left 0.3s ease;
  padding-bottom: 20rem;
}

@media (max-width: 991.98px) {
  .main-container {
    width: 100%;
    margin-left: 0;
  }

  .main-container.shifted {
    margin-left: var(--side-menu-width);
  }
}
</style>
